import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import {
  MDBBtn,
  MDBRow,
  MDBCol,
  MDBContainer,
  MDBTable,
  MDBTableBody,
  MDBTableHead,
  MDBModal,
  MDBModalHeader,
  MDBModalBody,
  MDBModalDialog,
  MDBModalContent,
} from 'mdb-react-ui-kit'
import LoadingSpinner from '../../shared/LoadingSpinner.component'
import Telephone from '../../shared/Telephone/Telephone.component'
import CarrierContactService from '../../../shared/services/CarrierContact.service'
import CarrierFmoService from '../../../shared/services/CarrierFmo.service'
import { toast } from 'react-toastify'

import './AgentContractGuideModal.component.scss'

const columns = [
  { label: 'Name', field: 'name' },
  { label: 'Email', field: 'email' },
  { label: 'Phone Number', field: 'phone' },
]

const AgentContractGuideModal = ({ isOpen, toggleModal, carrier, contract, postContractingOnly = false }) => {
  const [carrierContacts, setCarrierContacts] = useState([])
  const [carrierContractInstruction, setCarrierContractInstruction] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const fetchCarrierContactInfo = async () => {
    return new Promise((resolve, reject) => {
      CarrierContactService.search({
        search: { carrier_id: carrier?.get('id') },
        pagination: false,
      })
        .then(carrierContactInfos => resolve(carrierContactInfos && carrierContactInfos?.models))
        .catch(error => {
          throw error
        })
    })
  }

  const fetchCarrierContractInstructionByFmo = async () => {
    return new Promise((resolve, reject) => {
      CarrierFmoService.get(carrier?.get('fmo_id'))
        .then(carrierContractInstructionFmo =>
          resolve(carrierContractInstructionFmo && carrierContractInstructionFmo?.contracting_instructions)
        )
        .catch(error => {
          throw error
        })
    })
  }

  useEffect(() => {
    if (postContractingOnly) {
      setIsLoading(false)
      return
    }
    setIsLoading(true)

    Promise.all([fetchCarrierContactInfo(), fetchCarrierContractInstructionByFmo()])
      .then(response => {
        const [contactInfos, contractInstruction] = response
        setCarrierContacts(
          contactInfos?.map(infos => {
            return {
              name: infos?.name,
              email: infos?.email,
              phone: <Telephone phoneNumber={infos?.phone} />,
            }
          }) || []
        )
        setCarrierContractInstruction(contractInstruction)
        setIsLoading(false)
      })
      .catch(error => {
        toast.error('Failed to get carrier contacts and instructions', {
          position: toast.POSITION.TOP_RIGHT,
        })
        setIsLoading(false)
      })
  }, [carrier, contract, postContractingOnly])

  const postContractingContent = (
    <MDBRow>
      <MDBCol size='12' className='contracting-instruction-title'>
        After you've completed contracts
      </MDBCol>
      {carrier?.get('post_contracting_instructions') ? (
        <MDBCol
          size='12'
          className='contracting-instruction'
          dangerouslySetInnerHTML={{
            __html: carrier?.get('post_contracting_instructions'),
          }}
        />
      ) : (
        <MDBCol size='12' className='contacts-not-found'>
          No Instruction
        </MDBCol>
      )}
    </MDBRow>
  )

  const fullContent = (
    <>
      {isLoading ? (
        <LoadingSpinner
          size='md'
          isActive={isLoading}
          label={'Getting Carrier Contacts and Instructions'}
          className='loading-spinner'
        />
      ) : (
        <MDBContainer>
          <MDBRow>
            <MDBCol className='contacts-title' size='12'>
              Carrier Contacts
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol size='12' className='contacts-table-container'>
              <MDBTable striped bordered small className='text-capitalize text-truncate'>
                <MDBTableHead>
                  <tr>
                    {columns.map(column => (
                      <th key={column.field}>{column.label}</th>
                    ))}
                  </tr>
                </MDBTableHead>
                <MDBTableBody>
                  {carrierContacts.map((contact, index) => (
                    <tr key={index}>
                      {columns.map(column => (
                        <td key={column.field}>{contact[column.field]}</td>
                      ))}
                    </tr>
                  ))}
                </MDBTableBody>
              </MDBTable>
            </MDBCol>
          </MDBRow>

          <MDBRow>
            <MDBCol size='12' className='contracting-instruction-title'>
              Before you get started
            </MDBCol>
            {carrierContractInstruction ? (
              <MDBCol
                size='12'
                className='contracting-instruction'
                dangerouslySetInnerHTML={{
                  __html: carrierContractInstruction,
                }}
              />
            ) : (
              <MDBCol size='12' className='contacts-not-found'>
                No Instruction
              </MDBCol>
            )}
          </MDBRow>

          <MDBRow>
            <MDBCol size='12' className='contracting-instruction-title'>
              Carrier-Specific Instructions
            </MDBCol>
            {carrier?.get('contracting_instructions') ? (
              <MDBCol
                size='12'
                className='contracting-instruction'
                dangerouslySetInnerHTML={{
                  __html: carrier?.get('contracting_instructions'),
                }}
              />
            ) : (
              <MDBCol size='12' className='contacts-not-found'>
                No Instruction
              </MDBCol>
            )}
          </MDBRow>

          {postContractingContent}
        </MDBContainer>
      )}
    </>
  )

  const bodyContent = postContractingOnly ? <MDBContainer>{postContractingContent}</MDBContainer> : fullContent

  return (
    <MDBModal id='AgentContractGuideModalComponent' open={!!isOpen} onClose={toggleModal}>
      <MDBModalDialog className='contract-guide-modal'>
        <MDBModalContent>
          <MDBModalHeader>
            {carrier?.get('c_name')} Contract Guide
            <MDBBtn type='button' className='btn-close' color='none' onClick={toggleModal}></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>{bodyContent}</MDBModalBody>
        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
  )
}

export default observer(AgentContractGuideModal)
